import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface HudleChannelsTabProps {
  data: Record<string, any>;
}

export const HudleChannelsTab: React.FC<HudleChannelsTabProps> = ({ data }) => {
  const servers = data.servers || [];
  const allChannels: any[] = [];

  servers.forEach((server: any) => {
    if (server.channels && Array.isArray(server.channels)) {
      server.channels.forEach((channel: any) => {
        allChannels.push({
          ...channel,
          server_name: server.server_name,
          server_id: server.server_id,
        });
      });
    }
  });

  if (allChannels.length === 0) {
    return <S.EmptyState>Нет данных о каналах</S.EmptyState>;
  }

  return (
    <div>
      <S.SectionTitle>Каналы ({allChannels.length})</S.SectionTitle>
      {allChannels.map((channel: any, index: number) => (
        <S.ListItem key={index}>
          <S.ListItemTitle>
            {channel.channel_name} ({channel.server_name})
          </S.ListItemTitle>
          <S.InfoRow>
            <S.InfoLabel>ID канала</S.InfoLabel>
            <S.InfoValue>{channel.channel_id || '—'}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Тип</S.InfoLabel>
            <S.InfoValue>
              <S.Badge $variant="info">{channel.type || '—'}</S.Badge>
            </S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Приватный</S.InfoLabel>
            <S.InfoValue>
              <S.Badge $variant={channel.is_private ? 'warning' : 'success'}>
                {channel.is_private ? 'Да' : 'Нет'}
              </S.Badge>
            </S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Временный</S.InfoLabel>
            <S.InfoValue>
              <S.Badge $variant={channel.is_temporary ? 'warning' : undefined}>
                {channel.is_temporary ? 'Да' : 'Нет'}
              </S.Badge>
            </S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Сервер</S.InfoLabel>
            <S.InfoValue>{channel.server_name || '—'}</S.InfoValue>
          </S.InfoRow>
        </S.ListItem>
      ))}
    </div>
  );
};

